import styled from 'styled-components';
import { MainCharacteristics } from './MainCharacteristics';
import { Equipment } from './Equipment';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;

  @media (max-width: 1024px) {
    gap: 16px;
  }
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 12px;

  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 16.41px;
    margin-bottom: 0px;
  }
`;

export const VehicleCharacteristics = () => {
  return (
    <Wrapper>
      <Title>Vehicle Information</Title>
      <MainCharacteristics />
      <Equipment />
    </Wrapper>
  );
};
